exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".post_list[data-v-a3b404fc]{margin-bottom:2rem}.media[data-v-a3b404fc]{align-items:center}.media .media-content[data-v-a3b404fc]{overflow:visible}.thread-title[data-v-a3b404fc]{margin-bottom:.25rem}.date[data-v-a3b404fc]{font-size:.8rem;color:#999;margin-bottom:1rem}.comment[data-v-a3b404fc]{height:200px;overflow:hidden}.spec[data-v-a3b404fc]{position:absolute;right:1.5rem;bottom:1.5rem}article[data-v-a3b404fc]{transition:.2s}article[data-v-a3b404fc]:hover{z-index:1;transform:scale(1.05)}figure[data-v-a3b404fc]{overflow:hidden;border-radius:50%}figure img[data-v-a3b404fc]{filter:saturate(25%) brightness(1.05);transform:translateY(-10px)}.pagenav .button[data-v-a3b404fc]{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a3b404fc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Index.vue
// module id = 150
// module chunks = 0